<div id="page">
  <main>
    <div class="layout-container">
      <aside class="sidebar">
        <div class="settings">
          <hyperkit-typography variant="h3" align="center" color="primary">Settings</hyperkit-typography>
        </div>
        <div class="group" *ngFor="let group of sidebarData">
          <hyperkit-typography variant="label2" align="center" color="primary">{{ group.groupTitle }}</hyperkit-typography>
          <ul>
            <li
              *ngFor="let tab of group.items"
              [routerLink]="tab.routerLink"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <hyperkit-typography variant="body1" align="center" color="inherit"> {{ tab.menuTitle }}</hyperkit-typography>
            </li>
          </ul>
        </div>
        <div class="new" routerLink="/releases">
          Check out what's new in Version {{ latest }}
        </div>
      </aside>
      <div class="content-area">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>